export const PHONE_VERIFICATION = 'phone-verification';
